import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { NavigateToDefaultEntity } from "@web-src/features/app/components/NavigateToDefaultEntity/NavigateToDefaultEntity";
import LoginPage from "./Login/LoginPage";
import { SignUpPurpose } from "./SignUpPurpose";
import { SignUpInvitations } from "./SignUpInvitations";
import { SignUpNoInvitations } from "./SignUpNoInvitations";
import { ProfileForm } from "./ProfileForm";
import { SignUpNewWorkspace } from "./SignUpNewWorkspace";
import { SignUpNewWorkspaceSetup } from "./SignUpNewWorkspaceSetup";

export type AuthPagesNavigationParams = {
  authLogin: PageNavParams;
  authProfileForm: PageNavParams;
  authInvitations: PageNavParams;
  authNoInvitations: PageNavParams;
  authSignUpPurpose: PageNavParams;
  authNewWorkspace: PageNavParams<
    { flow: "inapp" | "signup" },
    { skipSelectProduct?: string }
  >;
  authWorkspaceSetup: PageNavParams<{ flow: "inapp" | "signup" }>;
  entryPoint: PageNavParams;
  entityEntryPoint: PageNavParams<{ targetEntityId: string }>;
};

export const authPagesNavigationConfig: ModulePagesConfig<AuthPagesNavigationParams> =
  {
    authLogin: {
      element: <LoginPage />,
      path: "login",
      isPrivate: false,
    },
    authProfileForm: {
      element: <ProfileForm />,
      path: "/profile-form",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: true,
    },
    authInvitations: {
      element: <SignUpInvitations />,
      path: "/invitations",
      isPrivate: true,
      isEntityOptional: true,
    },
    authNoInvitations: {
      element: <SignUpNoInvitations />,
      path: "/no-invitations",
      isPrivate: true,
      isEntityOptional: true,
    },
    authSignUpPurpose: {
      element: <SignUpPurpose />,
      path: "/signup-purpose",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: false,
    },
    authNewWorkspace: {
      element: <SignUpNewWorkspace />,
      path: "/org-create/:flow",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: false,
    },
    authWorkspaceSetup: {
      element: <SignUpNewWorkspaceSetup />,
      path: "/workspace-setup/:flow",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: false,
    },
    entityEntryPoint: {
      element: <NavigateToDefaultEntity />,
      path: "/entry-entity/:targetEntityId",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: false,
    },
    entryPoint: {
      element: <NavigateToDefaultEntity />,
      path: "/entry",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: false,
    },
  };
